module.exports = __webpack_public_path__ + "img/1280x720-Festival.8bae20e5.jpg";